<template>
  <div class="findlaw_hflss">
    <sec-title class="text_center" Text="合肥律师事务所" />
    <div class="cont between">
      <div><qestlawfirmlist /></div>
      <div><qestlawfirmlist /></div>
    </div>
  </div>
</template>

<script>
import secTitle from "views/home/components/secTitle";
import qestlawfirmlist from "../components/qestlawfirmlist";
export default {
  components: {
    secTitle,
    qestlawfirmlist,
  },
};
</script>

<style lang="scss" scope>
.findlaw_hflss {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  .cont {
    margin-top: 30px;
    > div {
      width: 580px;
      height: 300px;
    }
  }
}
</style>